import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import GlobalLoading from './components/GlobalLoading';
import Header from './components/Header/Header';
import Login from './components/Login/Login';
import GlobalAlert from './components/Modals/GlobalAlert';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedSellerRoute from './components/ProtectedSellerRoute';
import './fonts/icons/icons.font';
import Appointments from './pages/Appointments';
import Authentication from './pages/Authentication';
import Favorites from './pages/Favorites';
import Home from './pages/Home';
import MeProfile from './pages/MeProfile';
import MeProfileSettings from './pages/MeProfileSettings';
import Messages from './pages/Messages';
import Plans from './pages/Plans';
import Pricing from './views/Pricing/Pricing';
/* import Privacy from './pages/Privacy';
import HabeasData from './pages/HabeasData'; */
import Profile from './pages/Profile';
import Properties from './pages/Properties';
import Property from './pages/Property';
import RestorePassword from './pages/RestorePassword';
import PlanSelected from './pages/PlanSelected';
import LoginError from './pages/LoginError';
import SellerProperties from './pages/SellerProperties';
/* import Terms from './pages/Terms'; */
import ValidateEmail from './pages/ValidateEmail';
import PropertyNoBimmo from './pages/PropertyNoBimmo';
import GlobalHistory from './pages/useTrackerGoogle';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { CompanyTerms, Faq } from './views';
import DataPolitics from './views/DataPolitics';
import CookiesPolitics from './views/CookiesPolitics';
const theme = createMuiTheme();

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <GlobalHistory />
        <Login />
        <Header />
        <GlobalAlert />
        <GlobalLoading useGlobalLoading />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/properties" component={Properties} />
          <Route exact path="/properties/:id" component={Property} />
          <Route exact path="/inmueble/:id" component={PropertyNoBimmo} />
          <Route exact path="/profile/:id" component={Profile} />
          <Route exact path="/validate/:id/:code" component={ValidateEmail} />
          <Route exact path="/restore/:id/:code" component={RestorePassword} />
          <Route exact path="/token/:token" component={Authentication} />
          <Route exact path="/plan" component={PlanSelected} />
          <Route exact path="/login/error" component={LoginError} />
          <Route exact path="/pricing" component={Pricing} />
          <Route exact path="/faq" component={Faq} />
          <Route exact path="/companyTerms" component={CompanyTerms} />
          <Route exact path="/plans" component={Plans} />
          {/* <Route exact path="/terms" component={Terms} /> */}
          <Route exact path="/cookies-politics" component={CookiesPolitics} />
          <Route exact path="/data-politics" component={DataPolitics} />
          {/*           <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/habeas-data" component={HabeasData} /> */}
          <ProtectedRoute exact path="/favorites" component={Favorites} />
          <ProtectedRoute path="/messages/:chatId?" component={Messages} />
          <ProtectedRoute exact path="/me" component={MeProfile} />
          <ProtectedRoute
            exact
            path="/me/settings"
            component={MeProfileSettings}
          />
          <ProtectedRoute
            exact
            path="/me/properties"
            component={SellerProperties}
          />
          <ProtectedRoute path="/appointments" component={Appointments} />
          <ProtectedSellerRoute
            exact
            path="/seller/appointments"
            component={Appointments}
          />
        </Switch>
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}
